const isTest = process.env.REACT_APP_ENV === 'development';
module.exports.PricingUrls = {
    "starter-monthly": isTest ? "https://buy.stripe.com/test_3cs7vG41Ce0z4Eg8ww": "https://buy.stripe.com/5kA6qXgmD2Ka7cIdR2",
    "starter-annual": isTest ? "https://buy.stripe.com/test_00gaFr0Z53ym1hK28q" : "https://buy.stripe.com/9AQ4iP8Ub84ueFa28r",
  
    "growth-monthly": isTest ? "https://buy.stripe.com/test_8wMdRDgY3ed07G8fZa" : "https://buy.stripe.com/9AQ9D92vN70qaoU8wJ",
    "growth-annual": isTest ? "https://buy.stripe.com/test_8wMbJvdLRc4SgcEbIV" : "https://buy.stripe.com/00g6qXgmDacC54A3ct",
  
    "pro-monthly": isTest ? "https://buy.stripe.com/test_eVa28V4bh1qe8KcdR4" : "https://buy.stripe.com/4gw16D0nFfwW7cI00e",
    "pro-annual": isTest ? "https://buy.stripe.com/test_fZe14R37dc4Se4w00g" : "https://buy.stripe.com/fZe9D9gmD4Si68E28o",
  
    "business-monthly": isTest ? "https://buy.stripe.com/test_dR69BnePV7OC7G8cN1" : "https://buy.stripe.com/00g3eL4DVckKaoUbIX",
    "business-annual": isTest ? "https://buy.stripe.com/test_dR6fZL0Z56Ky4tW6oF" : "https://buy.stripe.com/14kcPl9Yf5WmfJe6oG",
  };